import './index.scss'

import Modal from '@components/Modal'

import closeIcon from 'url:@icon/close.svg';

export default function PeopleInfoModal(props: {
  isOpen: boolean,
  close: () => void
}) {
  return <Modal
    id='people-info-modal'
    isOpen={props.isOpen}
    footerButtons={[]}>
    <div className='people-info-modal-content'>
      <div className='header'>
        <button
          type='button'
          className='header-control close'
          onClick={props.close}>
          <img src={closeIcon} alt='Close icon' />
        </button>

        <h3 className='title'>About People</h3>

        <span className='header-control-spacer' />
      </div>

      <div className='body'>
        <h4>People Sources</h4>
        <p>People can be added to your church in three ways:</p>
        <ul>
          <li>Manually using the "New Person" button</li>
          <li>Automatically imported from Planning Center</li>
          <li>Automatically when someone creates a profile while using the Salt app with your church</li>
        </ul>
        <p>You can search for people using the search bar at the top of the page. You must search starting with someone's first name, or the beginning of their email address.</p>
      </div>
    </div>
  </Modal>
}
